import { LegalLayout, LegalH2, LegalP, LegalList, PH } from "@/components/landing/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated="Ottobre 2026" testid="privacy-page">
      <LegalH2>1. Titolare del trattamento</LegalH2>
      <LegalP>
        Il titolare del trattamento dei dati personali è <strong>MIRLO'S COMPANY LLC</strong>, con sede in Shams
        Media City, Al Mtsannid Suburb, Sharjah (UAE), License n. 2541494, Tax Registration Number
        105310671000001, contattabile all'indirizzo email <a href="mailto:info@miria.one" className="font-semibold text-purple-700 underline underline-offset-2">info@miria.one</a> (di seguito "il Titolare").
      </LegalP>

      <LegalH2>2. Ambito di applicazione</LegalH2>
      <LegalP>
        La presente informativa descrive come MIRLO'S COMPANY LLC raccoglie, utilizza e protegge i dati personali
        degli utenti che visitano questo sito e dei clienti che acquistano l'abbonamento MIR-IA Starter Pack. Il
        trattamento avviene nel rispetto del Regolamento (UE) 2016/679 ("GDPR"), del D.Lgs 196/2003 (Codice
        Privacy italiano) e del Decreto Legislativo Federale UAE n. 45/2021 in materia di protezione dei dati
        personali (PDPL), per quanto applicabili ai clienti residenti nell'Unione Europea e negli Emirati Arabi
        Uniti.
      </LegalP>

      <LegalH2>3. Dati personali che raccogliamo</LegalH2>
      <LegalList
        items={[
          "Dati identificativi e di contatto: nome, cognome, indirizzo email, numero di telefono, ragione sociale della tua attività;",
          "Dati fiscali e di fatturazione: indirizzo di fatturazione, partita IVA o codice fiscale, necessari per l'emissione delle fatture;",
          "Dati di pagamento: trattati esclusivamente da Stripe, nostro provider di pagamento. MIR-IA non vede né memorizza in alcun modo i dati completi della tua carta;",
          "Materiali e contenuti: foto, loghi, testi e informazioni sulla tua attività che ci fornisci per lo shooting fotografico e la creazione dei contenuti;",
          "Dati di navigazione: indirizzo IP, tipo di browser, pagine visitate, raccolti tramite cookie tecnici e log di sistema;",
          "Comunicazioni: il contenuto delle email e dei messaggi che ci invii per assistenza.",
        ]}
      />

      <LegalH2>4. Finalità e basi giuridiche del trattamento</LegalH2>
      <LegalList
        items={[
          "Esecuzione del contratto: attivazione dell'abbonamento, erogazione dei servizi (shooting, contenuti, assistente AI, guide) e assistenza clienti — base giuridica: esecuzione del contratto (art. 6.1.b GDPR);",
          "Adempimenti fiscali e contabili: emissione di fatture e conservazione delle scritture — base giuridica: obbligo legale (art. 6.1.c GDPR);",
          "Comunicazioni di servizio: email di conferma pagamento, benvenuto e avvisi sull'abbonamento — base giuridica: esecuzione del contratto e legittimo interesse;",
          "Comunicazioni promozionali su servizi analoghi — base giuridica: legittimo interesse (soft opt-in), con possibilità di opposizione in ogni momento;",
          "Sicurezza e prevenzione frodi sui pagamenti, tramite Stripe — base giuridica: legittimo interesse.",
        ]}
      />

      <LegalH2>5. Modalità del trattamento e sicurezza</LegalH2>
      <LegalP>
        I dati sono trattati con strumenti informatici e misure di sicurezza tecniche e organizzative adeguate:
        connessioni cifrate (HTTPS), accesso ai sistemi ristretto al personale autorizzato e pagamenti interamente
        gestiti da Stripe con certificazione PCI-DSS. Nessun processo decisionale automatizzato produce effetti
        giuridici sull'utente; i contenuti generati dall'assistente AI vengono sempre revisionati prima della
        pubblicazione. In caso di violazione dei dati personali (data breach) che possa presentare un rischio
        per i tuoi diritti e le tue libertà, ti informeremo senza ingiustificato ritardo e ne daremo notifica
        all'autorità di controllo competente entro 72 ore, secondo quanto previsto dagli artt. 33-34 del GDPR.
      </LegalP>

      <LegalH2>6. Soggetti che trattano i dati</LegalH2>
      <LegalP>
        Per erogare il servizio ci avvaliamo di fornitori selezionati che trattano i dati nel rispetto del GDPR o
        di garanzie equivalenti: Stripe (pagamenti e prevenzione frodi), Resend (invio delle email transazionali),
        il fornitore di hosting del sito e della piattaforma, e gli strumenti di intelligenza artificiale utilizzati
        per la generazione di idee e bozze di contenuti. L'elenco aggiornato è disponibile su richiesta. I dati
        non sono mai venduti né ceduti a terzi per finalità di marketing proprie.
      </LegalP>

      <LegalH2>7. Trasferimenti di dati fuori dall'UE</LegalH2>
      <LegalP>
        Il Titolare ha sede negli Emirati Arabi Uniti e alcuni fornitori operano negli Stati Uniti. Il
        trasferimento dei dati verso paesi extra-UE avviene solo verso soggetti che offrono garanzie adeguate
        (decisioni di adeguatezza, clausole contrattuali standard o accordi equivalenti) e limitatamente a quanto
        necessario per erogare i servizi acquistati.
      </LegalP>

      <LegalH2>8. Periodo di conservazione</LegalH2>
      <LegalList
        items={[
          "Dati contrattuali e di fatturazione: per la durata dell'abbonamento e per i 10 anni successivi, secondo gli obblighi fiscali;",
          "Materiali e contenuti forniti: per la durata dell'abbonamento, salvo tua richiesta di cancellazione anticipata;",
          "Dati per comunicazioni promozionali: fino alla tua opposizione o richiesta di cancellazione;",
          "Log di navigazione e sicurezza: massimo 12 mesi.",
        ]}
      />

      <LegalH2>9. I tuoi diritti</LegalH2>
      <LegalP>
        Ai sensi degli artt. 15-22 del GDPR puoi esercitare in qualsiasi momento i diritti di: accesso ai tuoi
        dati, rettifica, cancellazione ("diritto all'oblio"), limitazione del trattamento, portabilità dei dati e
        opposizione al trattamento, incluse le comunicazioni promozionali. Per esercitare i tuoi diritti scrivi a{" "}
        <a href="mailto:info@miria.one" className="font-semibold text-purple-700 underline underline-offset-2">info@miria.one</a>: risponderemo entro 30 giorni.
        Il Titolare, pur avendo sede al di fuori dell'Unione Europea, ha designato quale punto di contatto per
        gli interessati e le autorità di controllo dell'Unione l'indirizzo email info@miria.one (art. 27 GDPR).
      </LegalP>

      <LegalH2>10. Cookie</LegalH2>
      <LegalP>
        Questo sito utilizza esclusivamente cookie tecnici, necessari al funzionamento delle pagine, alla sicurezza
        e al completamento del pagamento (Stripe può installare cookie antifrode durante il checkout). Non sono
        utilizzati cookie di profilazione o di terze parti per finalità pubblicitarie, pertanto non è richiesto il
        consenso preventivo. Puoi comunque cancellare o bloccare i cookie dalle impostazioni del tuo browser.
      </LegalP>

      <LegalH2>11. Minori</LegalH2>
      <LegalP>
        I servizi MIR-IA sono rivolti a professionisti e attività commerciali: non raccogliamo consapevolmente
        dati di persone di età inferiore ai 18 anni.
      </LegalP>

      <LegalH2>12. Reclami</LegalH2>
      <LegalP>
        Se ritieni che il trattamento dei tuoi dati violi la normativa applicabile, puoi proporre reclamo al
        Garante per la protezione dei dati personali (www.garanteprivacy.it) o all'autorità di controllo del paese
        in cui risiedi. Ti invitiamo comunque a contattarci prima: faremo il possibile per risolvere insieme.
      </LegalP>

      <LegalH2>13. Modifiche alla presente informativa</LegalH2>
      <LegalP>
        Il Titolare può aggiornare questa informativa in qualsiasi momento; la versione vigente è quella
        pubblicata su questa pagina con la relativa data di aggiornamento. Le modifiche rilevanti ti saranno
        comunicate via email se sei un cliente attivo.
      </LegalP>
    </LegalLayout>
  );
}
